const selectZoneTypes = state => state.data.zoneTypes

const ZoneTypeDataStoreSelectors = {
  zoneTypes: selectZoneTypes
}

export default ZoneTypeDataStoreSelectors
